import React from 'react';
import { Empty, Spin, Box, CircularProgress } from '@mui/material';
import { MUIPagination } from '../../pagination';

const OptimizedList = ({ 
  data = [], 
  loading = false, 
  pageSize = 10, 
  current = 1, 
  total = 0, 
  onPageChange, 
  renderItem, 
  emptyText = "Nenhum item encontrado",
  className = "",
  style = {},
  gridMode = false
}) => {
  const totalPages = Math.ceil(total / pageSize);

  return (
    <div className={`optimized-list-container ${className}`} style={style}>
      {/* Lista de conteúdo */}
      <div className="optimized-list-content">
        {loading ? (
          <div className="optimized-list-loading" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
            <CircularProgress />
          </div>
        ) : data.length === 0 ? (
          <div className="optimized-list-empty">
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '300px', color: '#999' }}>
              <Box sx={{ fontSize: '3rem', marginBottom: '16px' }}>📭</Box>
              <p>{emptyText}</p>
            </Box>
          </div>
        ) : (
          <div className={gridMode ? "optimized-list-grid" : "optimized-list-list"}>
            {data.map((item, index) => {
              const renderedItem = renderItem(item, index);
              return renderedItem ? (
                <div key={index} className="optimized-list-item">
                  {renderedItem}
                </div>
              ) : null;
            })}
          </div>
        )}
      </div>

      {/* Paginação fixa na base */}
      {totalPages > 1 && (
        <div className="optimized-list-pagination-container">
          <MUIPagination
            count={totalPages}
            page={current}
            onChange={onPageChange}
            color="primary"
            size="medium"
            showFirstButton={totalPages > 5}
            showLastButton={totalPages > 5}
            boundaryCount={1}
            siblingCount={1}
          />
        </div>
      )}
    </div>
  );
};

export default OptimizedList;
